import { Component, Input } from '@angular/core';
import TeaserType from '../../../shared/enums/teaser.type.enums';
import { Teaser } from '../../../shared/interfaces/teaser.interface';
import { TeaserComponent } from '../../molecules/teaser/teaser.component';
import { CommonModule } from '@angular/common';
import { CapitalizePipe } from '../../capitalize.pipe';

@Component({
  selector: 'hdi-teaser-overview',
  standalone: true,
  imports: [CommonModule, TeaserComponent, CapitalizePipe],
  templateUrl: './teaser-overview.component.html',
  styleUrl: './teaser-overview.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class TeaserOverviewComponent {
  @Input() teasers: Teaser[] = [];
  @Input() teaserType: TeaserType = TeaserType.SIMPLE;
  @Input() columns: number = 2;
}
